<template>
  <div :class="prefixCls">
    <div class="contract-content">
      <div class="bd">
        <div class="bd-title tc bold">软装服务协议</div>
        <div style="text-align: center;margin-top:7px;">
          协议编号：{{ detail.orderCode }}
        </div>

        <div class="bd-main">
          鉴于买方委托住逻辑为其指定的室内项目提供软装设计或软装产品采买及安装陈设服务事宜达成如下协议
          共同遵守：
          <span class="f22 bold">第一条 定义</span>
          1.
          “住逻辑”是一个专业的软装设计及软装产品供应链管理服务平台，专业提供优质的云设计服务及丰富的软装产品生产商（包括但不限于提供原材料及生产制造服务）资源，以及专业的设计审核、原材料质检、生产品控、成品检控、配送和安装等供应链管理服务。
          2.
          “买方”是指拥有或推荐具体软装项目，并向住逻辑提出具体软装设计或软装产品采买需求的自然人或组织。
          3.
          “软装设计”或“软装产品”是指住逻辑根据买方确认的需求，提供软装设计方案或软装产品采买，包含家具、灯具、窗帘、地毯、挂画、饰品等家居品类的搭配设计、产品设计、生产安装及陈设，详见《软装设计方案》、《软装产品清单》。
          <span class="f22 bold">第二条 服务内容及协议条件</span>
          双方就买方所指定项目的软装设计或软装产品需求达成合作，并由买方全权委托住逻辑提供以下供应链管理服务：
          1.室内软装方案的设计及材质表现； 2.软装产品的采买陈设及交付安装：
          （1） 技术资料、设计图纸等的审核及建议； （2）
          原材料指定、设计参数指定及报价下单服务； （3）
          软装产品生产制造过程中的品质管控； （4） 软装产品的质量检验和验收；
          （5） 软装产品的运输、交付和安装； （6）
          软装产品的售后以及其他相关服务。
          合同期限、合同金额以及对应住逻辑平台上的订单编号详见《软装产品清单》约定。
          <span class="f22 bold">第三条 买方的权利与义务</span>
          1.买方应按约定的时间和方式与住逻辑确认软装设计方案或生产制造本协议项下所指定的软装产品所必需的技术资料、设计图纸等。
          2.买方向住逻辑提出具体的软装产品采买服务需求时，应遵循及时、完整、准确、真实的原则，以便于住逻辑履行相应义务。若因买方提供的需求信息有误或不完整导致住逻辑产生额外成本或费用的，买方应承担全部责任。
          3.买方授权且保证其有权授权住逻辑按照自身制定的品控及质检标准对本协议项下的软装产品的生产制造过程进行品质管控，并对制造完成的软装产品进行质量检验和验收。
          4.买方授权住逻辑有权自行决定将本协议项下的全部或部分服务内容转授权、匹配给多个不同第三方执行，且无需向买方披露或通知。
          5.买方授权住逻辑有权对本协议项下的软装产品进行拍照、摄像以及以软装产品为主题进行文字、图片宣传等，并同意授权住逻辑将其拍摄或创作完成的作品上传到住逻辑网站进行宣传推广。
          <span class="f22 bold">第四条 住逻辑的权利与义务</span>
          1.住逻辑有权且有义务对技术资料、设计图纸等进行审核确认，如住逻辑发现图纸、技术要求等有不合理处，有权向买方提出书面异议以及相关修改建议，如买方收到书面异议后未予答复或拒不更正的，则住逻辑有权终止合作，并不承担任何违约责任。
          2.住逻辑应及时、真实、准确地向买方反馈设计或生产制造本协议项下软装产品的报价，并在达成合作关系时，尽到谨慎和诚实义务。
          3.住逻辑负责根据其自身制定的品控标准对软装产品生产过程进行全程品质管控、成品质量检验和验收，保证最终交付给买方的软装产品符合行业规范及国家相关法律法规规定的安全、环保及质量要求。
          4.住逻辑应将其验收合格的软装产品按照买方指定的时间、地点和要求进行运输、交付及安装。如因买方原因导致住逻辑无法按时交付或安装的，住逻辑不承担任何违约责任，并且买方应承担由此产生的额外费用。
          5.住逻辑保证本协议项下交付的软装产品均质保两年，保修时间自交付验收之日起计算。保修期内，如出现非人为质量问题，住逻辑提供免费维修服务；确认不能修复的，住逻辑予以更换。若因买方原因造成软装产品损坏或超出保修期限的，住逻辑可协调提供维修服务，但需收取相应的维修费用。属于木材本身特质问题，如实木开裂纹、油漆强光变色等自然现象引起的美观问题，不属于住逻辑免费维修范围。
          <span class="f22 bold">第五条 服务费用及结算</span>
          1.住逻辑以其向买方提供的本协议项下的软装产品向买方收取对应的软装产品费用及供应链服务费用。具体详见《软装产品清单》或线上服务协议支付阶段文件。
          2.本协议项下涉及的软装产品金额、供应链服务费等明细由附件《软装产品清单》约定。
          <span class="f22 bold">第六条 知识产权和保密</span>
          1.买方享有本协议项下提供的有关软装产品的技术资料、设计图纸等知识产权，并仅授权住逻辑在本协议约定范围内使用。
          2.住逻辑享有以本协议项下软装产品为主题进行拍照、绘制、写作、摄像及加工完成的照片、图片、宣传文字及录像制品等的全部版权。
          3.买方在住逻辑服务期间应对本协议项下住逻辑提供的报价等商业信息进行保密，未经住逻辑书面同意，不得直接或间接向任何第三方故意或过失披露或泄露，否则，由此产生的所有直接或间接经济损失，应由买方予以赔偿。
          <span class="f22 bold">第七条 违约责任</span>
          1.买方违约责任
          （1）买方中途变更软装设计需求或软装产品的数量、规格、质量或设计等，应当及时通知住逻辑，若住逻辑已发生成本行为，买方需赔偿因此造成的损失。因变更设计或确认设计资料时间延误导致的交期顺延或成本增加由买方负责。
          （2）买方无故拒绝接收软装设计方案或软装产品，或不配合住逻辑或第三方服务商进行交付、安装的，应当赔偿由此造成的损失。
          （3）买方变更交付软装产品的地点或接收单位（人），应承担因此而多支出的费用；买方变更软装产品的交付时间，延长交货期超过一个月的，应支付造成的仓储费用。仓储费用为合同总额的
          5‰按天计算。
          （4）买方未按协议规定的时间和要求完成向住逻辑提供或确认技术资料、设计图纸等必要的辅助工作和准备工作，由此造成的责任与损失由买方承担。
          （5）非软装设计或软装产品交付期超过协议时间、生产质量不达标等的住逻辑违约条件，买方不能以软装设计或软装产品不喜欢、不满意为理由要求中途停止生产执行过程、拒绝交付安装验收或退换货等需求，否则由此造成住逻辑损失的，应由买方承担相应责任。
          （6）买方超过协议规定的期限仍未指定有效的交付地址或支付相关款项的，超过约定交货期3个月，并在住逻辑书面催告下仍不同意交付的，住逻辑有权将本协议项下的软装产品变卖，所得价款在扣除服务费、保管保养费后，退还给买方；变卖所得少于服务费、保管保养费总额时，买方还应补足；如软装产品不能及时变卖，买方应当赔偿住逻辑的损失。
          2.住逻辑违约责任
          （1）住逻辑未按协议规定的办法和期限对软装产品进行品质管控和质量检验，导致实际交付的软装设计方案或软装产品存在严重质量问题的，住逻辑应当负责进行整修或调换，依然不能满足交付条件的，应按要求退款或赔偿。
          （2）住逻辑交付的软装产品数量、质量、时间等未能按照买方要求的，对软装产品清单中不能交付的具体产品，住逻辑承担相应的损失。
          （3）住逻辑由于保管不善致使技术资料、设计图纸等毁损、灭失的，应当偿付买方因此造成的直接经济损失。
          （4）住逻辑由于交付执行过程中造成买方的其他损失，比如破坏原有建筑、硬装材料、软装产品等，由此造成的买方损失由住逻辑承担。
          （5）如因住逻辑原因导致逾期交付或逾期安装本协议项下的软装产品（不包括返修、更换、补交、增补等）的，则住逻辑应以逾期交付的产品所对应的供应链服务费为基数按每天5‰偿付。
          3.其他违约责任
          除本协议另有约定外，本协议任何一方因违反本协议而给另一方造成损失的，违约方须赔偿守约方相应的损失。
          <span class="f22 bold">第八条 不可抗力和其他除外责任</span>
          1.任何一方由于战争或严重的火灾、台风、地震、水灾或其他不能预见、不可避免和不能克服的事件而影响其履行协议所规定的义务的，受事故影响的一方将发生的不可抗力事件的情况以传真或其他有效方式通知另一方，并在事故发生后五天内以挂号信件或其他有效方式将有关当局或机构出具的证明文件提交另一方。
          2.由于发生不可抗力事件造成本协议不能履行、不能完全履行或延迟履行时，受不可抗力影响的一方应当立即将有关情况通知另一方，因不可抗力造成的任何损失均由受损失方自行承担。
          3.任何一方因不可抗力事件不能履行本协议全部或部分责任或义务时，应当免除其全部或者部分责任和义务，但均应及时通知另一方，并应在合理期限内提供有关机构出具的证明。
          4.双方同意如因政府红头文件、政策法律变更或其他合理情形导致住逻辑不能履行本协议时，比照不可抗力事件处理。
          5.其他除外责任：如因买方未按时付款等原因导致软装设计或软装产品未能按时交付的，进而导致住逻辑无法按时履行本协议项下约定的服务内容的，不视为住逻辑违约，住逻辑不承担任何赔偿责任。
          <span class="f22 bold">第九条 合同解除</span>
          1.买方未按照本协议及附属文件约定的时间进行付款且经住逻辑书面催告后仍未在十五日内付款的，住逻辑有权随时解除本协议，并无需承担任何违约责任。
          2.住逻辑未按照本协议或附属文件约定的时间进行交付且经买方书面催告后仍未在十五日内交付的，买方有权随时解除本协议，并无需承担任何违约责任。
          3.除前述条件以及双方协商一致解除本协议外，任何一方不得提前解除本协议。
          <span class="f22 bold">第十条 争议解决方式</span>
          因履行本协议所发生的或与本协议有关的一切争议、纠纷，双方应协商解决。协商不成的，双方可依法向上海市有管辖权的人民法院起诉。
          <span class="f22 bold">第十一条 其他</span>
          1.本协议条款未规定的，或者本协议条款的规定与国家法律法规等强制性规定相冲突的，按照国家法律法规或相关行业主管部门标准执行，没有行业标准的，参照国内外行业惯例执行。
          2.本协议内容包括协议正文、附件、住逻辑平台上协议对应的订单（订单编号见《软装产品清单》）及所有住逻辑已经制定实施或将来可能制定实施的服务标准（包括但不限于品控标准、质检标准，下同）、优惠条件等文件。这些文件是本协议不可分割的一部分，与本协议具有相同法律效力。如附件内容与本协议正文约定不一致，以附件内容为准。
          3.经双方同意，住逻辑有权以修改、更新等方式不时调整本协议和相关服务标准的内容，相关内容将作为附件，自住逻辑实施之日起开始生效。
          4.经双方同意，该协议对应住逻辑平台上的订单发生的一切补差价、退款及确认色板、面料以及图纸、产品信息等订单变更均体现在订单日志或修改单里，与本协议具有相同法律效力。
          5.若本协议任何条款被认定为无效或由于任何原因不可执行，则本协议其他条款仍然有效。被认定无效的条款自始无效，双方同意以最接近协议目的的条款来取代该无效条款。一方对另一方违约行为的默认或弃权将不导致也不能视为一方对另一方后续的或任何其他违约行为的默认或弃权。
          6.本协议由买方线上点击确认或线下签字后生效。
          如有其他附件，则为本协议不可分割的组成部分，具有同等法律效力。
          以下无正文。
          <div class="token">
            <div class="token-text" style="float:left">
              买方： 日期：{{ Date.parse(new Date()) | setTimeDateText }}
            </div>
            <div class="token-text token-text-right" style="float:right">
              <p v-if="detail.backInfo">
                卖方：{{ detail.backInfo.bankUserName }}
              </p>
              日期：{{ Date.parse(new Date()) | setTimeDateText }}
            </div>
            <div v-if="detail" class="token-img" style="left:900px;top:10px;">
              <img
                v-if="detail.partyBType === 1"
                src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/zhulogic/zhulogic-token.png"
              />
              <img
                v-if="detail.partyBType === 2"
                src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/logo/zhulogic-zhang8.jpg"
              />
              <img
                v-if="detail.partyBType === 3"
                src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/logo/zhulogic_YZ.png"
              />
              <img
                v-if="detail.partyBType === 4"
                src="https://oss.zhulogic.com/logo/sigma.png"
              />
            </div>
          </div>
          附件：
        </div>
        <div class="bd-table">
          <table>
            <tr>
              <td class="tc" style="line-height:50px;">
                软装产品清单
                <img
                  v-if="detail.partyBType === 4"
                  src="https://oss.sigmacloud.cn/house/logo/logoxxx.png"
                  class="contract-logo fr"
                  style="width:70px;float: right;margin-top: 14px;margin-right: 5px;"
                />
                <img
                  v-else
                  src="https://chain-apply.oss-cn-shanghai.aliyuncs.com/logo/zhulogic-logo.png"
                  class="contract-logo fr"
                  style="width:70px;float: right;"
                />
              </td>
            </tr>
          </table>

          <table>
            <tr>
              <td class="tc">
                订 单 编 号 Order Code：
              </td>
              <td class="tl">{{ detail.orderCode }}</td>
              <td class="tl">订单创建时间：{{ detail.createTime }}</td>
            </tr>
            <tr>
              <td class="tc">
                合 同 总 额 Total :
              </td>
              <td colspan="2" class="tl">
                {{ detail.totalPrice | currency('¥', '2') }}
              </td>
            </tr>
            <tr>
              <td class="tc">
                生 产 周 期 Production Cycle:
              </td>
              <td colspan="2" class="tl">{{ detail.cycle }}</td>
            </tr>
            <tr>
              <td class="tc">
                <div>付 款 方 式</div>
                <div>Pay Way:</div>
              </td>
              <td colspan="2" class="tl">{{ detail.payWay }}</td>
            </tr>
            <tr>
              <td class="tc">
                出 货 地 点 Dipatch Place:
              </td>
              <td colspan="2" class="tl">住逻辑产业园</td>
            </tr>
            <tr>
              <td class="tc">
                收 货 地 点 Place of receipt:
              </td>
              <td colspan="2" class="tl">{{ detail.recipientPlace }}</td>
            </tr>
            <tr v-if="detail.comment">
              <td class="tc">
                订单备注 Order Notes:
              </td>
              <td colspan="2" class="tl">{{ detail.comment }}</td>
            </tr>
            <tr>
              <td class="tc">
                说明 Description:
              </td>
              <td colspan="2" class="tl">
                <p>
                  1.
                  下列产品图片（或设计稿），因手工制作、上色及制作会作相应调整，产品图片与实物的规格、颜色及造型细节仅作参考，以生产放样或实物为准。
                </p>
                <p>
                  2.
                  天然材料制成的家具色泽、纹理可能会有色斑、节疤等特征，这都非质量问题，敬请选购时充分考虑。
                </p>
                <p>
                  3.
                  产品尺寸因为手工测量，或为图纸设计尺寸，如若与最终实施尺寸误差大于5%，需重新核价。
                </p>
                <p>4. 在执行过程中，如遇缺货断货的情况，经客户同意可替换。</p>
                <p>
                  5.
                  石材产品如需要做烤树脂面工艺需另外计价；木制混水亮光台面如需贴膜工艺需另外计价。
                </p>
                <p>
                  6.
                  大理石材料为天然产品，可能存在天然缺陷（如裂缝，砂眼，疏松，夹生，纹理色差等自然现象），本报价采用常规处理，如需要特殊选择，请联系客服。
                </p>
                <p>
                  7.
                  面料及床垫等其他信息请看详细备注。面料执行价格标准请询问住逻辑客服人员。
                </p>
              </td>
            </tr>
          </table>

          <div
            style="width:100%;overflow-x: scroll;-webkit-overflow-scrolling: touch;"
          >
            <table style="width:100%;">
              <tr>
                <td class="tc">序号</td>
                <td class="tc">区域</td>
                <td class="tc">名称</td>
                <td class="tc">产品图片</td>
                <td class="tc">材质</td>
                <td class="tc">面料明细</td>
                <td class="tc">
                  参考尺寸 W*D*H(MM)
                </td>
                <td class="tc">数量</td>
                <td class="tc">单位</td>
                <td class="tc">
                  单价 (RMB)
                </td>
                <td class="tc">
                  小计 (RMB)
                </td>
                <td class="tc">定制要求</td>
              </tr>
              <tr v-for="(item, index) in detail.detailedList" :key="index">
                <td class="tc">{{ index + 1 }}</td>
                <td class="tc">{{ item.area }}</td>
                <td class="tc">{{ item.name }}</td>
                <td class="tc">
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    class="bd-img"
                  />
                </td>
                <td class="tc">{{ item.material }}</td>
                <td class="tc">{{ item.fabric }}</td>
                <td class="tc">
                  <div
                    style="width:200px;word-wrap:break-word;word-break:break-all;"
                  >
                    {{ item.size }}
                  </div>
                </td>
                <td class="tc">{{ item.count }}</td>
                <td class="tc">件</td>
                <td class="tc">{{ item.unitPrice | currency('¥', '2') }}</td>
                <td class="tc">{{ item.price | currency('¥', '2') }}</td>
                <td class="tc">{{ item.remark }}</td>
              </tr>
              <tr>
                <td colspan="7" class="tc">产品总价</td>
                <td class="tl">{{ detail.productCount }}</td>
                <td colspan="4" class="tl">
                  {{ detail.productPrice | currency('¥', '2') }}
                </td>
              </tr>
              <tr>
                <td colspan="7" class="tc">
                  供应链服务费
                  <span v-if="detail.servicePrice && detail.servicePrice > 0">{{
                    detail.serviceCostDisplay
                  }}</span>
                </td>
                <td class="tc"></td>
                <td colspan="4" class="tl">
                  {{ detail.servicePrice | currency('¥', '2') }}
                </td>
              </tr>
              <tr v-if="detail.deduceFee && detail.deduceFee > 0">
                <td colspan="7" class="tc">恐龙蛋抵扣金额</td>
                <td class="tc"></td>
                <td colspan="4" class="tl">
                  {{ detail.deduceFee | currency('-¥', '2') }}
                </td>
              </tr>
              <tr v-if="detail.couponPrice && detail.couponPrice > 0">
                <td colspan="7" class="tc">优惠券抵扣金额</td>
                <td class="tl"></td>
                <td colspan="4" class="tl">
                  {{ detail.couponPrice | currency('-¥', '2') }}
                </td>
              </tr>

              <tr v-if="detail.businessDiscount && detail.businessDiscount > 0">
                <td colspan="7" class="tc">其他优惠</td>
                <td class="tl"></td>
                <td colspan="4" class="tl">
                  {{ detail.businessDiscount | currency('-¥', '2') }}
                </td>
              </tr>
              <tr v-if="detail.taxCost && detail.taxCost > 0">
                <td colspan="7" class="tc">税金</td>
                <td class="tl"></td>
                <td colspan="4" class="tl">
                  {{ detail.taxCost | currency('¥', '2') }}
                </td>
              </tr>
              <tr>
                <td colspan="7" class="tc">订单总价</td>
                <td class="tl"></td>
                <td colspan="4" class="tl">
                  {{ detail.totalPrice | currency('¥', '2') }}
                </td>
              </tr>
            </table>
          </div>
          <table v-if="detail.backInfo">
            <tr>
              <td class="tc">
                <div>公司名称：{{ detail.backInfo.bankUserName }}</div>
                <div>银行账号：{{ detail.backInfo.bankAccount }}</div>
                <div>开户行：{{ detail.backInfo.bankName }}</div>
              </td>
            </tr>
            <tr>
              <td colspan="12" class="tc" v-if="detail.partyBType == 4">
                www.sigmacloud.cn | 400-880-2857
              </td>
              <td v-else colspan="12" class="tc">
                www.zhulogic.com | 400-998-0137
              </td>
            </tr>
          </table>
        </div>
        <Row
          class="btn-row-bottom"
          :gutter="30"
          type="flex"
          justify="center"
          align="middle"
        >
          <Col span="5">
            <Button size="large" long @click="noConfirmHandle">暂不确认</Button>
          </Col>
          <Col span="5">
            <Button
              :loading="loading"
              size="large"
              class="primary-red"
              long
              type="primary"
              @click="confirmHandle"
              >确认合同</Button
            >
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
const prefixCls = 'zContract'
export default {
  name: 'ZContract',
  data() {
    return {
      prefixCls: prefixCls,
    }
  },
  props: {
    /* 合同主体 */
    txt: {
      type: Number,
      default: '',
    },
    detail: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /* 不确认 */
    noConfirmHandle() {
      this.$emit('noConfirm')
    },
    /* 确认 */
    confirmHandle() {
      this.$emit('confirm')
    },
  },
}
</script>
